import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { productPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";

const labelStyles = {
    size: 14,
    color: "text.accent",
    weight: "normal",
};

const valueStyles = {
    size: 14,
};

productPartNumbersStyles.erpNumberLabelText = mergeToNew(productPartNumbersStyles.erpNumberLabelText, {
    ...labelStyles,
});

productPartNumbersStyles.erpNumberValueText = mergeToNew(productPartNumbersStyles.erpNumberValueText, {
    ...valueStyles,
});

productPartNumbersStyles.customerNameLabelText = mergeToNew(productPartNumbersStyles.customerNameLabelText, {
    ...labelStyles,
});

productPartNumbersStyles.customerNameValueText = mergeToNew(productPartNumbersStyles.customerNameValueText, {
    ...valueStyles,
});

productPartNumbersStyles.manufacturerItemLabelText = mergeToNew(productPartNumbersStyles.manufacturerItemLabelText, {
    ...labelStyles,
});

productPartNumbersStyles.manufacturerItemValueText = mergeToNew(productPartNumbersStyles.manufacturerItemValueText, {
    ...valueStyles,
});
